import React from 'react'

import { NoxsysAbout } from './NoxsysAbout'
import { NoxsysSolution } from './NoxsysSolution'
import { NoxsysPartners } from './NoxsysPartners'

export const NoxsysSection: React.FC = () => {
    return (
        <div className="flex flex-col p-4 gap-4 items-center">
            <NoxsysAbout />
            <NoxsysSolution />
            <NoxsysPartners />
        </div>
    )
}
